module.exports = __webpack_public_path__ + "img/flt_pt_cors_bolt.prt.ed62fb81.jpg";